export default __webpack_public_path__ + "img/cjLibIBl.55639b81.svg";